var _path, _path2, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMainMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 213,
    height: 57,
    viewBox: "0 0 213 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M84.925 20.5V37H81.125V29.425L81.25 24.35H81.2L77.125 37H73.65L69.575 24.35H69.525L69.65 29.425V37H65.825V20.5H71.95L74.55 28.9L75.475 32.4H75.525L76.475 28.925L79.05 20.5H84.925ZM103.579 37H99.1539L98.0039 33.275H92.3539L91.1789 37H86.8539L92.6539 20.5H97.8039L103.579 37ZM93.1539 30.35H97.2039L95.1789 23.675L93.1539 30.35ZM109.798 20.5V37H105.498V20.5H109.798ZM128.332 20.5V37H123.557L118.432 28.075L117.182 25.625H117.157L117.257 28.675V37H113.457V20.5H118.232L123.357 29.425L124.607 31.875H124.632L124.532 28.825V20.5H128.332ZM158.24 20.5V37H154.44V29.425L154.565 24.35H154.515L150.44 37H146.965L142.89 24.35H142.84L142.965 29.425V37H139.14V20.5H145.265L147.865 28.9L148.79 32.4H148.84L149.79 28.925L152.365 20.5H158.24ZM161.894 37V20.5H174.744V23.825H166.194V27.175H172.994V30.3H166.194V33.675H175.069V37H161.894ZM192.541 20.5V37H187.766L182.641 28.075L181.391 25.625H181.366L181.466 28.675V37H177.666V20.5H182.441L187.566 29.425L188.816 31.875H188.841L188.741 28.825V20.5H192.541ZM210.621 20.5V30.275C210.621 32.6083 209.996 34.3583 208.746 35.525C207.513 36.675 205.679 37.25 203.246 37.25C200.829 37.25 198.996 36.675 197.746 35.525C196.496 34.3583 195.871 32.6083 195.871 30.275V20.5H200.196V30.35C200.196 31.5333 200.446 32.4167 200.946 33C201.463 33.5833 202.229 33.875 203.246 33.875C204.279 33.875 205.046 33.5833 205.546 33C206.063 32.4167 206.321 31.5333 206.321 30.35V20.5H210.621Z",
    fill: "#033656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.725 5H18.775C10.225 5 5 10.225 5 18.775V38.725C5 47.275 10.225 52.5 18.775 52.5H38.725C47.275 52.5 52.5 47.275 52.5 38.725V18.775C52.5 10.225 47.275 5 38.725 5Z",
    fill: "#0A3551"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 13,
    height: 13,
    rx: 5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 30,
    width: 13,
    height: 13,
    rx: 5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainMenu);
export default __webpack_public_path__ + "static/media/main-menu.ac5abb93c35ed878b13a62056716094d.svg";
export { ForwardRef as ReactComponent };